export default {
   initialCoupons: 0,
   coupons: [],
   progress: true,
   filterProgress: false,
};
